export default {
  install(app, _) {
    app.config.globalProperties.$className = {
      input: '',
      textarea: '',
      radio: {
        container: 'item-talk__selectbox',
        root: 'selectbox',
        input: 'radio',
        label: 'label'
      },
      checkbox: {
        container: 'item-talk__selectbox',
        root: 'selectbox',
        input: 'check',
        label: 'label'
      },
      select: {
        root: 'option'
      },
      error: 'error',
      m3LoginLink: {
        root: 'm3com-login',
        link: 'm3-button m3-button--primary m3com-login__btn'
      }
    };
  }
}; 